export default {
  devConfig: {
    apiKey: 'AIzaSyDGAoiM4oiOz5TNKW5Dub5h7ZNrAPZi_B8',
    authDomain: 'vettrivela-chitfund-developer.firebaseapp.com',
    databaseURL: 'https://vettrivela-chitfund-developer.firebaseio.com',
    projectId: 'vettrivela-chitfund-developer',
    storageBucket: 'vettrivela-chitfund-developer.appspot.com',
    messagingSenderId: '822212974627'
  },

  prodConfig: {
    apiKey: 'AIzaSyCIiw0T_pu4Pd6dX72WAJyNTjlNnB3ygek',
    authDomain: 'vettrivela-production-testing.firebaseapp.com',
    databaseURL: 'https://vettrivela-production-testing.firebaseio.com',
    projectId: 'vettrivela-production-testing',
    storageBucket: 'vettrivela-production-testing.appspot.com',
    messagingSenderId: '374399546813'
  }
};



// WEBPACK FOOTER //
// ./src/config/firebase.js